import React, { createContext } from 'react';
import RequestStore from './request-store';

export const RequestContext = createContext({});

export default ({ children }) => {
  return <RequestContext.Provider value={new RequestStore()}>{children}</RequestContext.Provider>;
};
